import React from "react";

export function EuStars({ size = 120, className = "" }) {
  const stars = Array.from({ length: 12 }, (_, i) => {
    const a = (i * 30 - 90) * (Math.PI / 180);
    return [50 + 36 * Math.cos(a), 50 + 36 * Math.sin(a)];
  });
  const star = (cx, cy, r = 5) => Array.from({ length: 10 }, (_, k) => {
    const a = (k * 36 - 90) * (Math.PI / 180);
    const rr = k % 2 === 0 ? r : r * 0.4;
    return `${cx + rr * Math.cos(a)},${cy + rr * Math.sin(a)}`;
  }).join(" ");
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className={className} aria-hidden="true">
      {stars.map(([x, y], i) => <polygon key={i} points={star(x, y)} fill="#FFCC00" />)}
    </svg>
  );
}

export function ProudRibbon({ text }) {
  return (
    <div className="flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.18em] text-[#FFCC00]" data-testid="proud-ribbon">
      <EuStars size={22} /> {text}
    </div>
  );
}
